// GENERATED by scripts/build-quiz-stats.js — do not edit by hand.
// Refresh with `npm run stats` before a deploy.
const quizStats = {
  "generated": "2026-07-26",
  "totalPlays": 45,
  "totalPlayers": 17,
  "firstPlay": "2026-04-25",
  "lastPlay": "2026-07-10",
  "legendCount": 0,
  "minSample": 5,
  "gamesRebuilt": "2026-07-26",
  "roundsSinceRebuild": 0,
  "hardestKey": "character",
  "easiestKey": "devilfruit",
  "games": [
    {
      "key": "character",
      "label": "Character Quiz",
      "path": "/quiz",
      "outOf": 15,
      "plays": 10,
      "abandoned": 2,
      "average": 7.5,
      "median": 8,
      "best": 11,
      "worst": 4,
      "perfect": 0,
      "perfectRate": 0,
      "difficulty": 50,
      "reliable": true
    },
    {
      "key": "image",
      "label": "Image Quiz",
      "path": "/image-quiz",
      "outOf": 15,
      "plays": 7,
      "abandoned": 2,
      "average": 8,
      "median": 10,
      "best": 11,
      "worst": 2,
      "perfect": 0,
      "perfectRate": 0,
      "difficulty": 53,
      "reliable": true
    },
    {
      "key": "bounty",
      "label": "Bounty Battle",
      "path": "/bounty-battle",
      "outOf": 11,
      "plays": 2,
      "abandoned": 0,
      "average": 10,
      "median": 10,
      "best": 11,
      "worst": 9,
      "perfect": 1,
      "perfectRate": 50,
      "difficulty": 91,
      "reliable": false
    },
    {
      "key": "devilfruit",
      "label": "Devil Fruit Quiz",
      "path": "/devil-fruit-quiz",
      "outOf": 15,
      "plays": 20,
      "abandoned": 2,
      "average": 14.3,
      "median": 15,
      "best": 15,
      "worst": 11,
      "perfect": 12,
      "perfectRate": 60,
      "difficulty": 95,
      "reliable": true
    }
  ]
};

export default quizStats;
